"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ContentRowRoot = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const ContentRowRoot = exports.ContentRowRoot = (0, _mui.styled)('div', {
    shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})((param)=>{
    let { isFocusPage, theme } = param;
    return {
        display: 'grid',
        columnGap: theme.spacing(2),
        rowGap: theme.spacing(isFocusPage ? 4 : 6),
        margin: 0,
        width: '100%',
        gridTemplateColumns: isFocusPage ? '1fr' : '1fr 1fr',
        [theme.breakpoints.up('sm')]: {
            columnGap: theme.spacing(3),
            gridTemplateColumns: isFocusPage ? '1fr 1fr' : '1fr 1fr 1fr 1fr',
            rowGap: theme.spacing(6)
        },
        [theme.breakpoints.up('md')]: {
            gridTemplateColumns: '1fr 1fr 1fr 1fr'
        },
        // eslint-disable-next-line @typescript-eslint/naming-convention -- It will ensure that elements will not shrink and stay same width
        '> *': {
            overflow: 'hidden'
        }
    };
});
